<template>
  <div id="grid-visita">
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="newVisita()">Agregar Visita</v-btn>
          </v-card-actions>
          <v-data-table
            :headers="headers"
            :items="visitas"
            :rows-per-page-items="rowsPerPageItems"
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.tipoVisita.descripcion }}</td>
              <td class="text-xs-left">{{ props.item.fechaVisita }}</td>
              <td class="text-xs-left">
                {{ props.item.estadoVisita.descripcion }}
              </td>
              <v-btn
                depressed
                outline
                icon
                fab
                dark
                color="green darken-4"
                small
                @click="viewVisita(props.item.id)"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  props.item.fechaVisita != null &&
                  props.item.fechaVisita != '' &&
                  props.item.fechaVisita != undefined
                "
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
                @click="editVisita(props.item.id)"
              >
                <v-icon>open_in_new</v-icon>
              </v-btn>
              <v-btn
                v-if="
                  props.item.fechaVisita == null ||
                  props.item.fechaVisita == '' ||
                  props.item.fechaVisita == undefined
                "
                depressed
                outline
                icon
                fab
                dark
                color="primary"
                small
                @click="editFecha(props.item.id)"
              >
                <v-icon>open_in_new</v-icon>
              </v-btn>
            </template>
          </v-data-table>
          <!-- LEYENDA TABLA PROVEEDORES -->
          <v-card-actions class="pb-3">
            <v-spacer></v-spacer>
            <div class="text-xs-center">
              <td>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="light-green"
                    small
                  >
                    <v-icon>remove_red_eye</v-icon> </v-btn
                  >Ver visita
                </template>
                <template>
                  <v-btn
                    class="btn-sigas"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="blue-grey darken-4"
                    small
                  >
                    <v-icon>open_in_new</v-icon> </v-btn
                  >Editar visita
                </template>
              </td>
            </div>
          </v-card-actions>
        </v-flex>
      </v-layout>
      <!-- dialogo    -->
      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Cambiar de estado</v-card-title>
          <v-card-text>Debe ingresar una fecha para la visita.</v-card-text>
          <!-- FECHA VISITA -->
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaVisita"
                label="Fecha Visita"
                prepend-icon="event"
                :readonly="
                  tipeView == 'consulta' ||
                  (tipeView == 'modifica' &&
                    fechaVisita != null &&
                    fechaVisita != '' &&
                    fechaVisita != undefined)
                "
                :box="
                  tipeView == 'consulta' ||
                  (tipeView == 'modifica' &&
                    fechaVisita != null &&
                    fechaVisita != '' &&
                    fechaVisita != undefined)
                "
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaVisita"
              @input="menu1 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
          <v-text-field
            v-if="tipeView == 'oculto'"
            v-model="idVisitaUpdate"
            label="ID Visita"
            :box="(isDisabled = true)"
            :readonly="(isDisabled = true)"
          ></v-text-field>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click="dialog = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" flat @click="insertFecha"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialogo -->
    </v-container>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import NewVisitaModal from "./NewVisitaModal.vue";
export default {
  name: "grid-visita",
  components: {},
  props: {
    contratoId: "",
    visitas: "",
    tipeView: "",
  },
  data() {
    return {
      loading: false,
      dialog: false,
      fechaVisita: new Date().toISOString().substr(0, 10),
      menu1: false,
      idVisitaUpdate: "",
      rowsPerPageItems: [20],
      pagination: {
        rowsPerPage: 20,
      },
      headers: [
        {
          text: "Tipo Visita",
          align: "left",
          sortable: false,
          value: "tipoVisita",
        },
        { text: "Fecha", sortable: false, value: "fecha" },
        { text: "Estado", sortable: false, value: "estado" },
        { text: "Accion", sortable: false, value: "" },
      ],
    };
  },
  mounted() {
    this.contratoId = this.$store.getters.contratoStored;
    if (
      this.contratoId == null ||
      this.contratoId == "" ||
      this.contratoId == undefined
    ) {
      this.contratoId = this.$route.params.contratoId;
      this.loadDataVisitas();
    } else {
      this.loadDataVisitas();
    }
  },
  computed: {},
  methods: {
    async loadDataVisitas() {
      //CARGA DE USUARIOS SEPARADOS POR TIPO
      this.visitas = await this.loadVisitsAll();
      this.visitasCont = this.visitas;
      this.loadFechaSelect();
    },

    loadFechaSelect() {
      let visi = [];
      this.visitas.forEach(function (v) {
        let index = visi.findIndex((x) => x.fechaVisita == v.fechaVisita);
        if (index === -1) {
          if (v.fechaVisita != null && v.fechaVisita != "") {
            visi.push(v.fechaVisita);
          }
        }
      });
      this.fechaInicioSelect = visi;
      this.fechaFinSelect = visi;
    },
    async loadVisitsAll() {
      let that = this;
      return await axios
        .get("/visitas/" + that.contratoId)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    openNewVisitaDialog() {
      this.tipoModal = "nuevo";
      this.dialog = !this.dialog;
      this.id = parseInt();
    },

    newVisita() {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistra",
          params: { tipeView: "crear" },
        });
      }, 1000);
    },

    viewVisita(id) {
      this.loading = true;
      this.$store.commit("visita_state", id);
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistra",
          params: { tipeView: "consulta" },
        });
      }, 1000);
    },

    editVisita(id) {
      this.loading = true;
      this.$store.commit("visita_state", id);
      setTimeout(() => {
        this.$router.push({
          name: "VisitaRegistra",
          params: { tipeView: "modifica" },
        });
      }, 1000);
    },

    async insertFecha() {
      await this.editFechaVisita();
      this.reloadGrid();
    },

    reloadGrid() {
      this.dialog = false;
      this.$parent.reloadVisitas();
    },

    formatoFecha(f) {
      // Convierte un texto de la forma 2017/01/10 a la forma
      return f.replace(/^(\d{4})-(\d{2})-(\d{2})$/g, "$3-$2-$1");
    },

    editFecha(id) {
      this.dialog = true;
      this.idVisitaUpdate = id;
    },

    async editFechaVisita() {
      let fechaVisitaFormat = this.formatoFecha(this.fechaVisita);
      let subProceso = this.$store.getters.subProTabSelectedStored;
      let idUserLogged = this.$store.getters.userLogged.id;
      let idContrato = this.$store.getters.contratoStored;

      this.body = {
        fechaVisita: fechaVisitaFormat,
        // idUserLogged: idUserLogged,
        subProceso: subProceso,
        idContrato: idContrato,
      };
      return await axios
        .put("/visita/" + this.idVisitaUpdate, this.body)
        .then((response) => {
          response.data;
          window.getApp.$emit("APP_SAVE");
        })
        .catch(function (error) {
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          console.log(error);
        });
    },
  },
};
</script>
